import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import ButtonUI from '../../../../components/UI/ButtonUI';
import Select from '../../../../components/UI/Select';
import SelectItem from "../../../../components/UI/SelectItem";
import ScannerCode from '../../../../components/UI/ScannerCode';
import Breadcrumbs from '../../../../components/UI/Breadcrumbs';
import InputUI from '../../../../components/UI/InputUI';
import { validateInputsRequired } from '../../../../utils/handleChangeHooks';
import { translate, isNullOrEmpty, showMessageToastCustom } from '../../../../utils/util';
import RoutePickingService from '../../../../services/RoutePickingService';

const PickingRouteUser = (props) => {
    const update = props.location?.state?.update;
    const [routeUser, setRouteUser] = useState(props.location?.state?.update && props.routeUser ? props.routeUser : {});
    const [routesArray, setRoutesArray] = useState([]);
    const [dataSource, setDataSource] = useState([]);
    const [usersFromElog, setUsersFromElog] = useState([]);

    const removedRouteArray = (item) => {
        const items = routesArray.filter((data) => data.id !== item.id);
        if (items) {
            setRoutesArray(items);
        }
    }

    const scanner = (value) => {
        routeUser.userName = value;
        setRouteUser(routeUser);
    };

    const addRouteUser = (item) => {
        const array = [];
        Object.assign(array, routesArray);
        const itemSelect = item.currentTarget.options[item.currentTarget.selectedIndex];
        const name = itemSelect.text;
        const id = Number(itemSelect.value);

        if (array.find((item) => item.id === id)) {
            return;
        }
        array.push({ id, name })
        setRoutesArray(array);
    }

    const addQueueAll = (value) => {
        if (value) {
            var item = props.routes?.items.find(f => f.id === parseInt(value));
            if (item && !routesArray.find(f => f.id === parseInt(value))) {
                routesArray.push({ id: value, name: item.code })
                setRoutesArray([...routesArray]);
            }
        }
    };


    const getListRouteUser = () => {
        let listResult = [];
        routesArray.forEach((route) => {
            let userName = routeUser?.userName;
            let routeId = Number(route.id);
            listResult.push({
                userName,
                routeId
            })
        });
        return listResult;
    }

    const loadRoutesOfUser = () => {
        let routesAux = [];
        if (!routeUser?.routes) {
            return;
        }

        routeUser.routes.forEach((item) => {
            let name = item.code;
            let id = item.id;

            routesAux.push({ id, name });
        });

        setRoutesArray(routesAux);
    }

    const getDataSource = () => {
        let dataSource = usersFromElog ? usersFromElog.map(item => {
            return {
                id: item.id,
                text: item.user
            }
        }) : []

        setDataSource(dataSource);
    }

    const getDefaultValue = () => {
        if (update && !isNullOrEmpty(routeUser?.userName)) {
            const userName = props.usersElog.find(
                item => item.userName === routeUser.userName);
            return !isNullOrEmpty(userName?.name) ? userName.name : routeUser.userName;
        }
        return '';
    }

    const onChangeData = (value) => {
        if (!isNullOrEmpty(value)) {
            routeUser.userName = value;
            setRouteUser(routeUser);
        }
    };

    useEffect(() => {
        getDataSource();
        // eslint-disable-next-line
    }, [usersFromElog])

    useEffect(() => {
        props.getRoutes();
        getListSelectUser();

        if (update) {
            loadRoutesOfUser();
        }
        // eslint-disable-next-line
    }, []);

    const redirect = () => {
        props.history.replace('./list');
    }

    const onConfirm = () => {
        if (routeUser.userName === undefined || routeUser.userName === '') {
            showMessageToastCustom(translate('general:warning'),
                translate('validations:invalid-user'),
                3000, 'mdi mdi-alert-circle-outline red-text');

            return;
        }

        if (validateInputsRequired("formRouteUserInsert")) {
            if (update) {
                props.updateRouteUser(getListRouteUser(), () => {
                    redirect();
                });
            } else {
                props.addRouteUser(getListRouteUser(), () => {
                    redirect();
                });
            }
        }
    };

    const getListSelectUser = () => {
        let users = [];
        props.usersElog.forEach(item => {
            users.push({
                id: item.userName,
                user: item.userName,
            });
        });

        props.usersElog.forEach(item => {
            users.push({
                id: item.userName,
                user: item.name,
            });
        });
        setUsersFromElog(users);
    }

    return (
        <div>
            <Breadcrumbs id="routeUserInsert" title={{ icon: "mdi mdi-map-marker-path", label: translate('route-user', 'route-picking') }}
                subtitles={[{ icon: "mdi mdi-plus-box-outline", label: update ? translate('menu.update', 'configuration') : translate('menu.attach', 'configuration') }]} />
            <div className="container-fluid" style={{ marginTop: '25px', }}>
                <div className="container">
                    <div className="card">
                        <div className="card-content" style={{ padding: '10px', paddingBlockEnd: '1px' }}>
                            <div id="formRouteUserInsert" className="row" style={{ marginBottom: '0px' }}>
                                <div className="input-field no-padding col s12">
                                    {
                                        update ?
                                            <InputUI disabled={update} label={translate('menu.user', 'configuration')} id="user" name="user" value={getDefaultValue()} />
                                            :
                                            <>
                                                <ScannerCode className={"mdi mdi-qrcode posfix"} onScanner={scanner} />
                                                <SelectItem
                                                    required
                                                    id="user"
                                                    name="user"
                                                    label={translate('menu.user', 'configuration')}
                                                    onChange={(event) => scanner(event.target?.value)}
                                                    onChangeData={onChangeData}
                                                    defaultValue={routeUser?.userName || ''}
                                                    data={dataSource}
                                                    disabled={update}
                                                />
                                            </>
                                    }
                                </div>
                                <div className="input-field no-padding col s12">
                                    <Select
                                        id="routes"
                                        name="routes"
                                        display="description"
                                        change={addRouteUser}
                                        multiple={true}
                                        changeAll={addQueueAll}
                                        label={translate('route', 'route-picking')}
                                        disablePlaceHoderSelect={true}
                                        data={props.routes?.items ? props.routes?.items.map((i) => { return { id: i.id, text: i.code }; }) : []}
                                        clearAll={() => {
                                            setRoutesArray([]);
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="row" style={{ paddingTop: '10px' }}>
                                {
                                    routesArray.length > 0 && routesArray.map((item) => (
                                        <div key={item.name} className="no-padding col s12">
                                            <div key={item.id + 1} className="title sixth-text-color">
                                                <i onClick={() => removedRouteArray(item)} className={`mdi mdi-24px mdi-alpha-x-circle-outline`} />
                                                {item.name}
                                            </div>
                                        </div>
                                    ))
                                }
                            </div>
                            <div className="row" style={{ paddingTop: '10px' }}>
                                <ButtonUI onClick={() => props.history.goBack()} text={translate('cancel', 'general')} secundary="true" />
                                <ButtonUI onClick={() => onConfirm()} text={translate('confirm', 'general')} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user,
        routes: state.pickingReducer.routes,
        routeUser: state.pickingReducer.routeUser,
        usersElog: state.usersElogReducer.usersElog,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getRoutes: () => {
            dispatch(RoutePickingService.getRoutes());
        },
        addRouteUser: (routes, callback) => {
            dispatch(RoutePickingService.addRouteUser(routes, callback));
        },
        updateRouteUser: (routes, callback) => {
            dispatch(RoutePickingService.updateRouteUser(routes, callback));
        }
    };
};


export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(PickingRouteUser)));
